import { useNotificationSocketContext } from '../contexts/NotificationSocketContext';

/**
 * Hook para acceder al socket de notificaciones (proyecto externo).
 * Conecta solo cuando el usuario está autenticado.
 * Usar subscribe(event, handler) para escuchar eventos; joinRoom(room) para unirse a una sala.
 */
export const useNotificationSocket = () => useNotificationSocketContext();
